function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSeat(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    "data-name": "Layer 2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 44.89 47.33",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("rect", {
    x: 2.89,
    y: 13.27,
    width: 6.67,
    height: 17.78,
    rx: 3,
    ry: 3,
    style: {
      fill: "#fff",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 36.22,
    y: 13.27,
    width: 6.67,
    height: 17.78,
    rx: 3,
    ry: 3,
    style: {
      fill: "#fff",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 19.55,
    y: 28.83,
    width: 6.67,
    height: 17.78,
    rx: 3,
    ry: 3,
    transform: "translate(60.6 14.83) rotate(90)",
    style: {
      fill: "#fff",
      strokeWidth: 0
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M31.39,5.5H14.38c-1.47,0-2.69,1.13-2.81,2.6l-1.77,22.14c-.13,1.64,1.16,3.04,2.81,3.04h20.56c1.65,0,2.94-1.4,2.81-3.04l-1.77-22.14c-.12-1.47-1.34-2.6-2.81-2.6Z",
    style: {
      fill: "#fff",
      strokeWidth: 0
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSeat);
export default __webpack_public_path__ + "static/media/seat.5063ab8347e76114a7497da5d9fc5c4e.svg";
export { ForwardRef as ReactComponent };